import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { Spin, Row, Col } from 'antd';

// Ленивая загрузка страниц с правильными путями
const HomePage = lazy(() => import('../pages/home-pages/home-pages'));
const CatalogPage = lazy(() => import('../pages/catalog-page/catalog-page'));
const ProductPage = lazy(() => import('../pages/product-page/product-page'));
const CartPage = lazy(() => import('../pages/cart-page/cart-page'));
const ContactsPage = lazy(() => import('../pages/contacts-page/contacts-page'));
// const DeliveryPage = lazy(() => import('../pages/DeliveryPage/DeliveryPage'));
// const NotFoundPage = lazy(() => import('../pages/NotFoundPage/NotFoundPage'));

// Компонент загрузки
const LoadingSpinner = () => (
    <Row justify="center" align="middle" style={{ minHeight: '50vh' }}>
        <Col>
            <Spin size="large" />
        </Col>
    </Row>
);

const AppRoutes = () => {
    return (
        <Suspense fallback={<LoadingSpinner />}>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/catalog" element={<CatalogPage />} />
                <Route path="/catalog/:category" element={<CatalogPage />} />
                <Route path="/product/:id" element={<ProductPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/contacts" element={<ContactsPage />} />
                {/*<Route path="/delivery" element={<DeliveryPage />} />*/}
                {/*<Route path="*" element={<NotFoundPage />} />*/}
            </Routes>
        </Suspense>
    );
};

export default AppRoutes;